/** NAV-1 role line — 06-03 names from the token, never a hard-coded "Admin". */

const ROLE_LABELS: { test: (token: string) => boolean; label: string }[] = [
  {
    test: (t) => t === 'ROLE-COR-001' || t === 'BA_ADMIN' || t === 'BA_MANAGER',
    label: 'Business Account Manager',
  },
  {
    test: (t) => t === 'ROLE-COR-004' || t === 'BA_FINANCE',
    label: 'Finance Contact',
  },
  {
    test: (t) => t === 'ROLE-COR-002' || t === 'BA_APPROVER',
    label: 'Department Approver',
  },
  {
    test: (t) => t === 'ROLE-COR-003' || t === 'BA_EMPLOYEE',
    label: 'Business Employee',
  },
];

function roleTokens(roles: readonly string[] | string | null | undefined): string[] {
  if (roles == null) return [];
  const list = typeof roles === 'string' ? [roles] : [...roles];
  return list.map((role) => role.trim().toUpperCase()).filter(Boolean);
}

export function businessRoleLabel(
  roles: readonly string[] | string | null | undefined,
): string | null {
  const tokens = roleTokens(roles);
  for (const entry of ROLE_LABELS) {
    if (tokens.some((token) => entry.test(token))) return entry.label;
  }
  return null;
}

export function slugifyAccountName(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'account';
}

export function accountSlugFor(account: {
  id?: string | null;
  tradingName?: string | null;
  legalName?: string | null;
}): string {
  const fromName = slugifyAccountName(account.tradingName || account.legalName || '');
  if (fromName !== 'account') return fromName;
  if (account.id) return slugifyAccountName(account.id);
  return 'account';
}

export function accountSlugMatches(
  param: string | null | undefined,
  account: {
    id?: string | null;
    tradingName?: string | null;
    legalName?: string | null;
  },
): boolean {
  if (!param?.trim()) return true;
  const expected = accountSlugFor(account).toLowerCase();
  const actual = param.trim().toLowerCase();
  if (actual === expected) return true;
  if (account.id && actual === account.id.toLowerCase()) return true;
  return false;
}
